// Unit mapping only. Scientific formulas and MPE policy remain on the server.
export function massGrams(value: number, unit: string): number {
  const factor = { kg: 1000, g: 1, mg: .001 }[unit];
  if (!factor || !massHasNumber(value)) { throw new Error('واحد یا مقدار جرم معتبر نیست.'); }
  const grams = Number(value) * factor;
  if (!Number.isFinite(grams)) { throw new Error('مقدار تبدیل‌شده جرم متناهی نیست.'); }
  return grams;
}
export function massHasNumber(value: any): boolean {
  return (typeof value === 'number' || typeof value === 'string' && value.trim() !== '') && Number.isFinite(Number(value));
}
// Reject gross unit mistakes; specification/acceptance decisions belong to the server.
export function massMagnitudeMatches(nominalGrams: number, observedGrams: number): boolean {
  return observedGrams > 0 && observedGrams >= nominalGrams / 10 && observedGrams <= nominalGrams * 10;
}
export function serializeMassEntry(raw: any): any {
  const request = JSON.parse(JSON.stringify(raw));
  if (request.ContractVersion != null && ![1, 2].includes(Number(request.ContractVersion))) {
    throw new Error('نسخه قرارداد Mass پشتیبانی نمی‌شود.');
  }
  request.ContractVersion = 2;
  // These are legacy UI labels, not properties of MassModel/ModelBase. Order
  // and receipt metadata are read by the backend from the calibration request.
  ['TypeClass','OrderNumber','ReceiptDate'].forEach(key => delete request[key]);
  const measurements: any[] = [];
  const nominals: string[] = [];
  request.Groups.forEach(group => group.Measurements.forEach(m => {
    if (m.LegacyCycles && m.LegacyCycles.length) { throw new Error('مرحله یا تعارض قرائت‌های قبلی هنوز تعیین تکلیف نشده است.'); }
    const readingUnit = m.Unit;
    m.NominalDisplayUnit = m.NominalDisplayUnit || readingUnit;
    nominals.push(String(m.NominalValue) + ' ' + m.NominalDisplayUnit);
    m.NominalValue = massGrams(m.NominalValue, m.NominalDisplayUnit);
    m.TheoreticalSPool = m.TheoreticalSPool == null ? null : massGrams(m.TheoreticalSPool, readingUnit);
    ['Cycles', 'AsLeftCycles'].forEach(key => (m[key] || []).forEach(c => {
      c.ReferenceValues = c.ReferenceValues.map(v => massGrams(v, readingUnit));
      c.TestValues = c.TestValues.map(v => massGrams(v, readingUnit));
    }));
    if (m.AdjustmentPerformed === false && (m.AsLeftCycles || []).length) {
      throw new Error('قرائت‌های بعد از تنظیم موجود است؛ وضعیت تنظیم را بررسی کنید.');
    }
    m.AsFoundCycles = m.Cycles; delete m.Cycles;
    delete m.LegacyCycles; delete m.LegacyCycleStage;
    m.Unit = 'g'; measurements.push(m);
  }));
  request.NominalRange = request.NominalRange || nominals.join(', ');
  request.Groups = [{ Unit: 'g', Measurements: measurements }];
  // Nullable alternatives are UI state, not zero-valued double inputs. The form
  // requires an explicit U/u (or half-width/u) before a complete input is sent.
  const optional = ['DoF', 'RelativeErrorOfUncertainty', 'StandardUncertainty', 'ExpandedUncertainty', 'HalfWidthOfLimit', 'CoverageFactor'];
  const cleanParameter = (p: any) => {
    if (!p) { return; }
    optional.forEach(key => { if (p[key] == null) { delete p[key]; } });
  };
  Object.keys(request.WeightInput).filter(key => key !== 'Items').forEach(key => cleanParameter(request.WeightInput[key]));
  request.WeightInput.Items.forEach(item => ['Msn','MsnUncertainty','DmCal','DmDrift'].forEach(key => cleanParameter(item[key])));
  return request;
}
